module.exports = __webpack_public_path__ + "static/media/transmute-loading-white.11fb6556.gif";